




























































































import Vue from 'vue'
import ExercisesBasics from '@/components/exercises/measure/ExercisesBasics.vue'
import ExercisesBeginning from '@/components/exercises/measure/ExercisesBeginning.vue'
import ExercisesCardio from '@/components/exercises/measure/ExercisesCardio/ExercisesCardio.vue'
import ExercisesStrengthenings from '@/components/exercises/measure/ExercisesStrengthenings.vue'
import ExercisesEnd from '@/components/exercises/measure/ExercisesEnd.vue'
import ExercisesNav from '@/components/exercises/components/ExercisesNav.vue'
import ExerciseDialog from '@/components/exercises/components/ExerciseDialog.vue'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/exercise/keys'
import { LoadingTypes } from '@/store/modules/exercise/types'
import { mapActions, mapGetters, mapState } from 'vuex'
import { FlatPatientExercise } from '@/store/modules/exercise/getters'

export default Vue.extend({
  components: {
    ExercisesBasics,
    ExercisesBeginning,
    ExercisesCardio,
    ExercisesStrengthenings,
    ExercisesEnd,
    ExercisesNav,
    ExerciseDialog,
  },
  data() {
    return {
      isInitialLoading: true as boolean,
      isEditable: false as boolean,
      isOpenDialog: false as boolean,
      isDeleting: false as boolean,
      deletionCandidateId: '' as string,
      navSize: 0 as number,
    }
  },
  computed: {
    ...mapState(ModuleNames.exercise, ['loading']),
    ...mapGetters(ModuleNames.exercise, [GetterNames.exercise]),
    ...mapGetters(ModuleNames.exercise, {
      exercises: GetterNames.exercises,
    }),
    showPartialLoading(): boolean {
      return this.loading === LoadingTypes.PARTIAL
    },
    showFullScreenLoading(): boolean {
      return this.loading === LoadingTypes.FULL_SCREEN
    },
    exercise(): FlatPatientExercise {
      return this[GetterNames.exercise](this.$route.params.exercise_id)
    },
    commonBindData(): { isEditable: boolean; exercise: FlatPatientExercise } {
      return {
        isEditable: this.isEditable,
        exercise: this.exercise,
      }
    },
    commonBindEvent(): { 'update:exercise-param': (name: string, value: any) => void } {
      return {
        'update:exercise-param': this.updateExerciseParam,
      }
    },
    dialogTitle(): string {
      const candidateExercise = this.exercises.find(exercise => exercise.id === this.deletionCandidateId)
      return candidateExercise ? `Delete an Exercise Data (${candidateExercise.exerciseDate})` : ''
    },
  },
  async mounted(): Promise<void> {
    this.isEditable = this.$route.query.edit !== undefined
    await this[ActionNames.getExercises]()

    if (this.exercise === null) {
      this.$router.replace({ name: '404' })
    }
    this.isInitialLoading = false

    this.getNavSize()
    window.addEventListener('resize', this.getNavSize)
  },
  async beforeRouteUpdate(to, from, next): Promise<void> {
    this.isEditable = to.query.edit !== undefined
    if (to.params.exercise_id === from.params.exercise_id) {
      return next()
    }

    this.isInitialLoading = true
    await this[ActionNames.getExercises]()

    const exercise = this[GetterNames.exercise](to.params.exercise_id)
    if (exercise === undefined) {
      await this.$router.replace({ name: '404' })
      return
    }

    this.isInitialLoading = false
    next()
  },
  beforeDestroy(): void {
    window.removeEventListener('resize', this.getNavSize)
  },
  methods: {
    ...mapActions(ModuleNames.exercise, [
      ActionNames.postExercise,
      ActionNames.getExercises,
      ActionNames.patchExercise,
      ActionNames.deleteExercise,
      ActionNames.updateExercise,
    ]),
    async postExercise(patientId): Promise<void> {
      const newExerciseId = await this[ActionNames.postExercise]({ patientId })
      await this.$router.push({ name: 'exercises-detail', params: { exercise_id: newExerciseId }, query: { edit: '' } })
    },
    async patchExercise(): Promise<void> {
      await this[ActionNames.patchExercise]({ id: this.exercise.id })
    },
    async deleteExercise(): Promise<void> {
      this.isDeleting = true
      const patientId = this.exercise.patientId
      await this[ActionNames.deleteExercise]({ exerciseId: this.deletionCandidateId })
      this.isDeleting = false
      this.isOpenDialog = false
      await this.$router.push({ name: 'exercises-report', params: { patient_id: patientId } })
    },
    updateExerciseParam(name: string, value: any): void {
      const { id, ...attributes } = this.exercise
      this[ActionNames.updateExercise]({
        id,
        attributes: {
          ...attributes,
          [name]: value,
        },
      })
    },
    updateEditState(value: boolean): void {
      if (value) {
        this.$router.replace({ query: { edit: '' } })
      } else {
        this.$router.replace({ query: {} })
      }
    },
    openDialog(): void {
      this.isOpenDialog = true
      this.deletionCandidateId = this.exercise.id
    },
    finishEditing(): void {
      this.patchExercise()
      this.updateEditState(false)
    },
    getNavSize(): void {
      const nav = this.$refs.nav as Element
      this.navSize = nav.getBoundingClientRect().width
    },
  },
})
